"use client";

import { ServerErrorAlert } from "@offstreetparking/portal-flow/components/forms/Alert";
import { useRouter } from "next/navigation";
import { use, useEffect } from "react";
import { CommonLayout } from "~/components/layouts/CommonLayout";
import { offstreetClient } from "~/services/offstreetApi";

type KioskPageProps = {
	params: Promise<{
		kioskId: string;
		path?: string[];
	}>;
};

export default function KioskPage({ params }: KioskPageProps) {
	const { kioskId } = use(params);

	const router = useRouter();
	const parsedKioskId = Number(kioskId);
	const isValidKioskId = Number.isInteger(parsedKioskId) && parsedKioskId > 0;

	const {
		data: locationLookup,
		isPending,
		error: queryError,
	} = offstreetClient.locationLookup.getLocationLookupByKioskId.useQuery(
		{ kioskId: parsedKioskId },
		{ enabled: isValidKioskId },
	);

	useEffect(() => {
		if (locationLookup) {
			router.replace(`/location/${locationLookup.locationLookupId}`);
			return;
		}

		if (!isValidKioskId || !isPending) {
			router.replace("/");
			return;
		}
	}, [isValidKioskId, isPending, locationLookup, router]);

	if (queryError) {
		return (
			<CommonLayout>
				<ServerErrorAlert serverError={queryError} />
			</CommonLayout>
		);
	}

	return null;
}
